module.exports = __webpack_public_path__ + "media/assets/images/flags/ye-08959b6245687ca5a3cd952da2ad8b24.svg";